"use client";

import { useMemo } from "react";
import { useActionMenuContribution } from "@/app/private-shell";
import { useChatBot } from "@/features/chat";
import { useAuth } from "@/state/globalStore";

export default function BacklogActionMenuContribution() {
  const owner = "backlog-route";
  const { isUserAdmin } = useAuth();
  const { handleChatWithProfileClick, preparingChat } = useChatBot();

  const quickActions = useMemo(
    () =>
      isUserAdmin
        ? [
            {
              key: "chat_profile",
              label: "Chat",
              humanReadable: "Chat with your profile",
              icon: "chat" as const,
              closeOnSelect: true,
              onSelect: handleChatWithProfileClick,
              disabled: preparingChat,
            },
          ]
        : [],
    [handleChatWithProfileClick, isUserAdmin, preparingChat],
  );

  useActionMenuContribution({
    owner,
    quickActions,
  });

  return null;
}
